import { toast } from "sonner";
import { api, errText } from "@/lib/api";
import { shortDate } from "@/lib/eventMeta";

/** Move an entry to another date, with an undo action on the toast. */
export const moveEvent = async (event, date, reload) => {
  try {
    const { data } = await api.patch(`/events/${event.event_id}/move`, { date });
    reload?.();
    toast.success(`Moved to ${shortDate(date)}`, {
      description: event.title,
      action: {
        label: "Undo",
        onClick: async () => {
          try {
            await api.patch(`/events/${event.event_id}/move`, { date: data.from });
            reload?.();
            toast.success(`Back on ${shortDate(data.from)}`);
          } catch (e) {
            toast.error(errText(e));
          }
        },
      },
    });
  } catch (e) {
    toast.error(errText(e));
  }
};
